import React from "react";
import "../styles/list.css";
import { UserResponse } from "../types/AuthTypes";
import { deleteUser } from "../services/authService";
import { useNavigate } from "react-router-dom";

interface UserTableProps {
  users: UserResponse[];
  loadUsers: () => void;
}

const UserTable: React.FC<UserTableProps> = ({ users, loadUsers }) => {
  const navigate = useNavigate();

  // Function to handle delete
  const handleDelete = async (id: number) => {
    if (window.confirm("Are you sure you want to delete this user?")) {
      await deleteUser(id);
      alert("User deleted successfully!");
      loadUsers();
    }
  };

  const convertUtcToLocal = (utcDateString: string) => {
    return new Date(utcDateString + "z").toLocaleString();
  };

  return (
    <div className="overflow-x-auto message-table">
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Role</th>
            <th>Created Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => (
            <tr key={user.id} className="hover:bg-gray-100">
              <td>{user.firstName} {user.lastName}</td>
              <td>{user.email}</td>
              <td>{user.role}</td>
              <td>{convertUtcToLocal(user.createdDate)}</td>
              <td className="button-group">
                <button
                    className="update-btn"
                    onClick={() => navigate(`/register/${user.id}`)}
                  >
                    Detail
                </button>                
                <button
                  className="delete-btn"
                  onClick={() => handleDelete(user.id)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default UserTable;
